<template>  
  <format
    :msg="$t('online-casino')"
    :type-game="2"
    :src="require('@/assets/nav/submenu/icon_submenu2.svg')"
  />
</template>
<script>  
import format from './childs/format'

export default { 
  components : {
    format
  },   
} 
</script> 